// angular import
import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { RTL, LTR } from 'src/app/@theme/const';

// project import
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { UsPasswordComponent } from 'src/app/demo/pages/application/profile/user-profiles/us-password/us-password.component';
import { ChangePasswordComponent } from 'src/app/tabms/components/admin/change-password/change-password.component';
import { userInfo } from 'src/app/tabms/models/base/base';
import { AccountService } from 'src/app/tabms/services/admin/account/account.service';
import { NotificationsFollowUpService } from 'src/app/tabms/services/admin/notifications/notifications-follow-up/notifications-follow-up.service';
import { Auth2Service } from 'src/app/tabms/services/Auth/auth2Service.service';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { SignalrManagerService } from 'src/app/tabms/services/global/signalr-manager.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-right',
  templateUrl: './toolbar-right.component.html',
  styleUrls: ['./toolbar-right.component.scss']
})
export class NavRightComponent implements OnInit, AfterViewChecked {
  // public props
  @Output() HeaderBlur = new EventEmitter();
  @Input() isDashboard: boolean = false;

  userName;
  userEmail;
  userImageUrl;
  profileImage: string;
  companyName: string;
  currentLang;
  user: userInfo;
  private destroy$: Subject<void> = new Subject<void>();

  // constructor
  constructor(
    private translate: TranslateService,
    private auth2Service: Auth2Service,
    private renderer: Renderer2,
    private layoutService: ThemeLayoutService,
    private changeDetector: ChangeDetectorRef,
    public dialog: MatDialog,
    private sessionService: SessionWrapperService,
    private accountService: AccountService,
    private baseService: BaseService,
    private router: Router
  ) {
    this.translate.onLangChange.subscribe((e) => {
      this.companyName = e.lang === 'ar' ? this.user?.companyaraname : this.user?.companylatname;
      this.sessionService.setCompanyName(this.companyName);
    });

  }

  getLanguage(): string {
    let lang: string = 'ar';
    const langJson = localStorage.getItem('language');
    lang = langJson == null ? 'ar' : langJson;
    return lang;
  }
  NotificationList: any[] = [];
  ngOnInit() {
    // fill NotificationList from backend
    this.translate.setDefaultLang(this.getLanguage()); //'ar'
    this.setRtlLayout(this.getLanguage() == 'ar' ? true : false);
    let session = this.sessionService.getsessionData();

    this.accountService.GetUserLoginWithRoleData(session.userid).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        // console.log('GetUserLoginWithRoleData', res);
        if (res) {
          this.user = res.result[0];
          this.userName = this.user?.username;
          this.userEmail = this.user?.email;
          this.userImageUrl = this.user?.pofileimage;
          this.companyName = this.currentLang === 'ar' ? this.user?.companyaraname : this.user?.companylatname;

          this.profileImage = this.user?.pofileimage;
        }
        this.sessionService.setUserName(this.userName);
        this.sessionService.setCompanyName(this.companyName);
      },
      error: (err) => {
      }
    });
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  // public method
  // user according language change of sidebar menu item
  useLanguage(language: string) {
    this.translate.use(language);
    this.setRtlLayout(language == 'ar' ? true : false);
    localStorage.setItem('language', language);
    this.changeDetector.detectChanges();
  }

  // rtl theme layout
  setRtlLayout(rtl: boolean) {
    if (rtl) {
      this.renderer.addClass(document.body, 'able-pro-rtl');
      //this.rtlLayout = true;
      this.layoutService.directionChange.next(RTL);
    } else {
      this.renderer.removeClass(document.body, 'able-pro-rtl');
      //this.rtlLayout = false;
      this.layoutService.directionChange.next(LTR);
    }
  }

  headerBlur() {
    this.HeaderBlur.emit();
  }

  // user Logout
  logout() {
    this.auth2Service.logout();
    localStorage.clear();
    sessionStorage.clear();
  }

  changePassword() {
    this.dialog.open(ChangePasswordComponent, {
      width: '800px',
      direction: this.baseService.getDirection()
    });
  }

  notifyClicked() {
    this.router.navigate(['real-estate/pre-customers', 'db09dbd5-2a2a-408f-bea6-6e5806a99736'])
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
